export default __webpack_public_path__ + "static/media/menstrual-health.1ba8a887.png";